<p>site-config-qr-page works!</p>
